import { gql } from '@apollo/client';

export default gql`
  mutation impulseUpgrade(
    $exchangeItems: [Int!]
    $reference: String!
    $currency: Currency!
    $fromSTDtoSP: Boolean
    $fromSTDtoBP: Boolean
    $fromSPtoBP: Boolean
  ) {
    impulseUpgrade(
      exchangeItems: $exchangeItems
      reference: $reference
      currency: $currency
      fromSTDtoSP: $fromSTDtoSP
      fromSTDtoBP: $fromSTDtoBP
      fromSPtoBP: $fromSPtoBP
    ) {
      reference
    }
  }
`;
